import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import VerifiedOutlinedSvg from "@ant-design/icons-svg/es/asn/VerifiedOutlined";
import AntdIcon from "../components/AntdIcon";
var VerifiedOutlined = function VerifiedOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: VerifiedOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  VerifiedOutlined.displayName = 'VerifiedOutlined';
}
export default /*#__PURE__*/React.forwardRef(VerifiedOutlined);